export default "__VITE_ASSET__BqgPBsBo__"